import { validateTidalLicense } from "../../base/index.js";
import { colorToRGBA } from "./colorToRGBA.js";
validateTidalLicense();
function getColorSqDistance(from, to) {
  const [r1, g1, b1, a1] = colorToRGBA(to);
  const [r2, g2, b2, a2] = colorToRGBA(from);
  const dRSquared = (r2 - r1) * (r2 - r1);
  const dBSquared = (g2 - g1) * (g2 - g1);
  const dGSquared = (b2 - b1) * (b2 - b1);
  const dASquared = (a2 - a1) * (a2 - a1);
  const distSquared = dRSquared + dGSquared + dBSquared + dASquared;
  return distSquared;
}
export {
  getColorSqDistance
};
//# sourceMappingURL=getColorSqDistance.js.map
